import { render, staticRenderFns } from "./SickLeaveRequestClosingModal.vue?vue&type=template&id=b31a0b2a&scoped=true&"
import script from "./SickLeaveRequestClosingModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveRequestClosingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31a0b2a",
  null
  
)

export default component.exports